export type ClipTimeRange = {
  clip_start_time?: number | null;
  clip_end_time?: number | null;
};

/** The clip's time range as `createClip` segments; empty when the range is
 *  missing or not positive, so callers can treat the clip as unexportable. */
export function clipTimeSegments(clip: ClipTimeRange): { start: number; end: number }[] {
  const { clip_start_time: start, clip_end_time: end } = clip;
  if (typeof start !== 'number' || typeof end !== 'number' || end <= start) return [];
  return [{ start, end }];
}
